/**
 * Texts for header
 */
export const headerText = {
    cookiesIntroText: 'Nous utilisons des cookies qui ne servent qu’à suivre vos visites sur notre site. Nous ne stockons aucune donnée personnelle.',
    cookiesAccept: 'Accepter les cookies',
    cookiesDeny: 'Refuser les cookies',
    tabFAQs: 'Questions',
    tabSupport: 'Assistance',
    tabHistory: 'Notre histoire',
    tabReviews: 'Histoires',
    tabTraining: 'Formation',
    tabUserTraining: 'Formation utilisateurs',
    tabHcpTraining: 'Formation pro-santé',
    tabCamAPSLiberty: 'CamAPS Liberty',
    tabPregnancy: 'Grossesse',
    tabAbout: 'À propos',
    tabNews: 'Actualités',
    tabCareers: 'Carrières',
    tabOrders: '',
    tabNotifications: 'Notifications',
};
